/* eslint-disable no-unused-expressions */
import { useEffect, useMemo } from "react";
import { gql, useQuery } from "@apollo/client";

import { createNewApolloClient } from "src/shared/utilities/graphql/newApolloClient";

const client = createNewApolloClient({ credentials: "include" });
const startedExperiments = {};

export const QUERY = gql`
  query ab_tests($input: AbTestsInput!) {
    ab_tests(input: $input) {
      experiment
      variant
      fireable
    }
  }
`;

export const startExperiment = (experiment, label) =>
  global?.dataLayer?.push?.({
    event: "split_experiment_start",
    event_action: "start",
    event_category: "split_experiment",
    event_label: `${experiment}:${label}`
  });

const useAbTests = experiments => {
  const { data, error, loading } = useQuery(QUERY, {
    client,
    variables: {
      input: {
        experiments
      }
    }
  });

  useEffect(() => {
    data?.ab_tests?.forEach?.(ab_test => {
      if (ab_test.fireable && !startedExperiments[ab_test.experiment]) {
        startExperiment(ab_test.experiment, ab_test.variant);
        startedExperiments[ab_test.experiment] = true;
      }
    });
  }, [data]);

  const abTests = useMemo(
    () =>
      data?.ab_tests?.reduce?.(
        (result, abTest) => ({
          ...result,
          [abTest.experiment]: abTest.variant
        }),
        {}
      ) ?? null,
    [data]
  );

  return { loading, error, ...abTests };
};

export default useAbTests;
